import { Injectable } from "@angular/core";
import { RestService } from "../../../services/rest.service";
import { CreateIntegrationConfigurationDto } from "../dto/create-integration-configuration.dto";
import { UpdateIntegrationConfigurationDto } from "../dto/update-integration-configuration.dto";
import { IntegrationConfiguration } from "../interface/integration-configuration.interface";

@Injectable({
    providedIn: 'root'
})
export class IntegrationConfigurationApi {

    private readonly endpoint = 'integration-configuration';

    constructor(private restService: RestService) {
    }

    create(createIntegrationConfigurationDto: CreateIntegrationConfigurationDto) {
        return this.restService.send<IntegrationConfiguration>({
            url: this.endpoint,
            method: 'POST',
            body: createIntegrationConfigurationDto
        })
    }

    readAll() {
        return this.restService.send<IntegrationConfiguration[]>({
            url: this.endpoint,
            method: 'GET'
        })
    }

    readById(id: string) {
        return this.restService.send<IntegrationConfiguration>({
            url: `${this.endpoint}/${id}`,
            method: 'GET'
        })
    }

    update(id: string, updateDto: UpdateIntegrationConfigurationDto) {
        return this.restService.send<IntegrationConfiguration>({
            url: `${this.endpoint}/${id}`,
            method: 'PUT',
            body: updateDto
        })
    }

    delete(configId: string) {
        return this.restService.send({
            url: `${this.endpoint}/${configId}`,
            method: 'DELETE'
        })
    }

    findByIntegrationName(integrationName: string) {
        return this.restService.send<IntegrationConfiguration[]>({
            url: `${this.endpoint}/search?integrationName=${integrationName}`,
            method: 'GET'
        })
    }

    uploadTimesData(hotelAuthKey: string, hotelId: string, guestData: any, period: string, environment: string) {
        return this.restService.send<any>({
            url: `${this.endpoint}/times/upload`,
            body: {
                hotelAuthKey: hotelAuthKey,
                hotelId: hotelId,
                guestData: guestData,
                period: period,
                environment: environment
            },
            method: 'POST'
        })
    }

    testTimeConnection(hotelAuthKey: string, hotelId: string, environment: string) {
        return this.restService.send<any>({
            url: `${this.endpoint}/times/test`,
            query: {
                hotelAuthKey: hotelAuthKey,
                hotelId: hotelId,
                environment: environment
            },
            method: 'GET'
        })
    }

    submitTimesData(hotelAuthKey: string, hotelId: string, environment: string, period: string) {
        return this.restService.send<any>({
            url: `${this.endpoint}/times/submit`,
            body: {
                hotelAuthKey: hotelAuthKey,
                hotelId: hotelId,
                environment: environment,
                period: period
            },
            method: 'POST'
        })
    }
}